import { render } from "./ZoneShapesTable.vue?vue&type=template&id=c8787a00&ts=true"
import script from "./ZoneShapesTable.ts?vue&type=script&lang=ts"
export * from "./ZoneShapesTable.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__